import { REMOVE_APP_SETTINGS, SET_APP_SETTINGS } from "../../constants/actionTypes";
import _ from "lodash";

const getInitAppSettingState = () => {
    const appSettings = localStorage.getItem('app_settings');
    if (!_.isEmpty(appSettings)) {
        return JSON.parse(appSettings);
    }
    return {};
};

const initialState = getInitAppSettingState();

const settingReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_APP_SETTINGS:
            return action.payload
        case REMOVE_APP_SETTINGS:
            return {};
        default:
            return state;
    }
};

export default settingReducer;